import { createStandardAction } from 'typesafe-actions';

export const toggleZopim = createStandardAction('TOGGLE_ZOPIM')<void>();
